export default [{"tag":"path","att":{"d":"M4 10.0723h16v-2H4v2zm0 6h16v-2H4v2z"}}]